import { callouts, colors } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import { CSSProperties } from "react";

export const container: CSSProperties = {
  marginTop: 10,
  marginBottom: 10,
  marginRight: 10,
};

export const moreInfo: CSSProperties = {
  maxHeight: 0,
  transition: "max-height .4s, margin-top .4s",
  overflow: "hidden",
  marginTop: 0,
};

export const moreInfoExpanded: CSSProperties = {
  ...moreInfo,
  maxHeight: 150,
  marginTop: spacing.sm,
};

export const containerLink: CSSProperties = {
  borderBottomWidth: 0,
  color: colors.yellow.darker,
};

export const icon: CSSProperties = {
  color: callouts.warning.color,
  fontSize: size.md,
  width: "50%",
};
